import { services, frequencies } from "@/mocks/homeData";

export default function ServicesSection() {
  const scrollToContact = () => {
    const el = document.querySelector("#contacto");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="servicios" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3">
            Nuestros Servicios
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Limpieza profesional para
            <span className="text-teal-600"> cada espacio</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Ofrecemos soluciones de limpieza personalizadas para hogares, apartamentos, oficinas y mudanzas. Contáctanos para una cotización sin costo.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {services.map((service) => (
            <div
              key={service.id}
              className={`rounded-2xl bg-gradient-to-br ${service.color} p-8 flex flex-col md:flex-row gap-6 group hover:scale-[1.01] transition-transform duration-200`}
            >
              {/* Icon */}
              <div className={`w-16 h-16 flex items-center justify-center rounded-2xl bg-white shrink-0 ${service.iconColor}`}>
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">{service.description}</p>
                <ul className="grid grid-cols-2 gap-1">
                  {service.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-1.5 text-xs text-gray-600">
                      <i className="ri-check-line text-teal-500 shrink-0"></i>
                      {feat}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Frequencies */}
        <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-8 md:p-12">
          <div className="text-center mb-8">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
              Elige tu frecuencia
            </h3>
            <p className="text-gray-500">Nos adaptamos a tu ritmo de vida</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            {frequencies.map((freq) => (
              <div
                key={freq.id}
                className="bg-white rounded-xl p-5 text-center hover:shadow-md transition-shadow cursor-default"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-xl mx-auto mb-3">
                  <i className={`${freq.icon} text-teal-600 text-xl`}></i>
                </div>
                <div className="font-bold text-gray-900 text-sm">{freq.label}</div>
                <div className="text-xs text-gray-500 mt-1">{freq.desc}</div>
              </div>
            ))}
          </div>
          <div className="text-center">
            <p className="text-gray-600 mb-4 font-medium">
              <i className="ri-information-line text-teal-500 mr-1"></i>
              Contáctanos para una cotización personalizada sin costo
            </p>
            <button
              onClick={scrollToContact}
              className="bg-teal-500 hover:bg-teal-600 text-white font-bold px-8 py-3.5 rounded-full transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
            >
              <i className="ri-file-list-3-line"></i>
              Solicita tu Cotización Ahora
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
